import { render, staticRenderFns } from "./AddAccount.vue?vue&type=template&id=9c5c22be&scoped=true&"
import script from "./AddAccount.vue?vue&type=script&lang=js&"
export * from "./AddAccount.vue?vue&type=script&lang=js&"
import style0 from "./AddAccount.vue?vue&type=style&index=0&id=9c5c22be&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5c22be",
  null
  
)

export default component.exports